export const nominaLabel =[ 
    {color: "red", icon: "cancel red", key: "NO_LABEL", value: "NO_LABEL", text: "Quitar etiqueta"},
    {color: "orange", icon: "payment orange", key: "TARJETA_CREDITO", value: "TARJETA_CREDITO", text: "Pago con Tarjeta"},
    {color: "olive", icon: "tags olive", key: "PASARELA_PAGO", value: "PASARELA_PAGO", text: "Pasarela de pago"},
    {color: "violet", icon: "ban violet", key: "PROVEEDOR_EXCLUIDO", value: "PROVEEDOR_EXCLUIDO", text: "Proveedor excluido"},
    {color: "teal", icon: "handshake outline teal", key: "PAGO_TERCERO", value: "PAGO_TERCERO", text: "Pago por un tercero"},
    {color: "yellow", icon: "question circle outline yellow", key: "PROVEEDOR_POR_CONFIRMAR", value: "PROVEEDOR_POR_CONFIRMAR", text: "Confirmar proveedor"},
    {color: "red", icon: "exclamation circle red", key: "PROVEEDOR_CRITICO", value: "PROVEEDOR_CRITICO", text: "Proveedor crítico"},
]

export const filterNominaLabel =[ 
    {color: "black", icon: "add black", key: "NO_LABEL", value: "NO_LABEL", text: "Sin etiqueta"},
    {color: "orange", icon: "payment orange", key: "TARJETA_CREDITO", value: "TARJETA_CREDITO", text: "Pago con Tarjeta"},
    {color: "olive", icon: "tags olive", key: "PASARELA_PAGO", value: "PASARELA_PAGO", text: "Pasarela de pago"},
    {color: "violet", icon: "ban violet", key: "PROVEEDOR_EXCLUIDO", value: "PROVEEDOR_EXCLUIDO", text: "Proveedor excluido"},
    {color: "teal", icon: "handshake outline teal", key: "PAGO_TERCERO", value: "PAGO_TERCERO", text: "Pago por un tercero"},
    {color: "yellow", icon: "question circle outline yellow", key: "PROVEEDOR_POR_CONFIRMAR", value: "PROVEEDOR_POR_CONFIRMAR", text: "Confirmar proveedor"},
    {color: "red", icon: "exclamation circle red", key: "PROVEEDOR_CRITICO", value: "PROVEEDOR_CRITICO", text: "Proveedor crítico"},
]

export const documentFilter =[ 
    {color: "teal", icon: "file teal", key: "CREATED", value: "CREATED", text: "En Nómina"},
    // {color: "orange", icon: "university orange", key: "IN_BANK", value: "IN_BANK", text: "En banco"},
    // {color: "olive", icon: "tasks olive", key: "PROCESSED", value: "PROCESSED", text: "Procesada"},
    // {color: "green", icon: "check circle outline green", key: "APPROVED", value: "APPROVED", text: "Aprobada"},
    {color: "blue", icon: "check circle", key: "SELECTED", value: "SELECTED", text: "Seleccionado"},
]

export const nominaStatus = {
    CREATED: {label: 'Descargar', icon: "download", color: "green"},
    DELETED: {label: "Nómina eliminada", icon: "trash red", color: "red"},
    INFORMED: {label: "Procesando", icon: "loading", color: "yellow"},
    BANKLOADED: {label: "En Banco", icon: "university green", color: "green"},
    PAID: {label: "Pagada"},
    REJECTED: {label: 'Rechazada'},
    MANUAL: {label: "Proceso Manual", icon: "tasks", color: "orange"},
    PROCESSED: {label: "Procesada", icon: "folder outline", color: "teal"},
    SMARTCFO_INFORM: {label: "Informar", icon: "send outline", color: "teal"},
    SMARTCFO_INFORMED: {label: "Nómina Enviada", icon: "check circle outline outline", color: "teal"},
}

export const nominaStatusConection = {
    CREATED: {label: 'Nómina Creada', icon: "clipboard outline", color: "blue"},
    DELETED: {label: "Nómina eliminada", icon: "trash red", color: "red"},
    INFORMED: {label: "Procesando", icon: "loading", color: "yellow"},
    BANKLOADED: {label: "En Banco", icon: "university green", color: "green"},
    PAID: {label: "Pagada"},
    REJECTED: {label: 'Rechazada'},
    MANUAL: {label: "Nómina Manual", icon: "tasks", color: "orange"},
    PROCESSED: {label: "Procesada", icon: "folder outline", color: "teal"},
}

export const nominaStatusLabel = {
    PENDING: { label: "Por Pagar", icon: "clock outline", color: "yellow" },
    APPROVED: {label: "Aceptada", icon: "clock outline", color: "grey"},
    REJECTED: {label: "Rechazada", icon: "times circle outline", color: "red"},
}

export const nominaStatusLabelByIsPaid = {
    false: { label: "Pendiente", icon: "clock outline", color: "yellow" },
    true: {label: "Pagada", icon: "check circle outline", color: "green"},
}

export const allowedToUseBot = ["santander", "bankItau", "bci"] // Agregar los templateId a medida que se finalizan los bot --> ["bci", "bankItau", "bankChile2", "santander"]